<template>
  <Tag :value="$t(`brands.environment_${environment}`)" :severity="severity" class="text-xs" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import Tag from 'primevue/tag';

import type { BrandEnvironment } from '@/types/enums';

type Severity = 'success' | 'warn' | 'info' | 'secondary';

const props = defineProps<{
  environment: BrandEnvironment;
}>();

const severity = computed<Severity>(() => {
  switch (props.environment) {
    case 'production': {
      return 'success';
    }
    case 'production_test': {
      return 'warn';
    }
    case 'staging': {
      return 'info';
    }
    default: {
      return 'secondary';
    }
  }
});
</script>
